// The API turns away a request whose body arrives too slowly (e.g. an upload on a poor connection), with a message
export default {
  notification: {},
}
